import { useEffect, useState } from 'react';
import MonitorCreator from './components/MonitorCreator'
import EmailVerificationToast from './components/EmailVerificationToast';

function App() {
  const [showEmailVerificationToast, setShowEmailVerificationToast] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('emailVerification') === 'success') {
      setShowEmailVerificationToast(true);
      urlParams.delete('emailVerification');
      const newUrl = window.location.pathname + (urlParams.toString() ? `?${urlParams.toString()}` : '');
      window.history.replaceState({}, '', newUrl);
    }
  }, []);

  return (
    <>
      <MonitorCreator />
      <EmailVerificationToast 
        show={showEmailVerificationToast}
        onClose={() => setShowEmailVerificationToast(false)}
      />
    </>
  );
}

export default App